var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-control pvc-tree"},_vm._l((_vm.data),function(datum){return _c('pvc-tree-node',{key:datum.id,staticClass:"tree-item",attrs:{"data":datum,"input":_vm.input,"totalPercentage":_vm.totalPercentage}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }